module.exports = __webpack_public_path__ + "img/QRenglish.77d48f18.png";